// Route: /faq — публичная отдельная страница «Помощь / Частые вопросы».
// Тот же `FaqSection`, что и десятая секция лендинга, но в варианте `page`:
// без регистра «10 · Вопросы» — сквозной номер имеет смысл только там, где есть
// остальные девять ящиков. Своего header нет — он есть в MainLayout.

import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { FaqSection } from "@/components/public/landing/faq-section";
import { PageMeta } from "@/components/seo/PageMeta";

export const Route = createFileRoute("/faq")({
	component: FaqPage,
});

function FaqPage(): React.ReactElement {
	const { t } = useTranslation("landing");
	return (
		<>
			<PageMeta title={t("faq.title")} description={t("faq.title")} path="/faq" />
			<FaqSection variant="page" />
		</>
	);
}
